export function sortBy(objArray, fieldName, asc = true) {
  objArray.sort((a, b) => {
    return asc ? a[fieldName] - b[fieldName] : b[fieldName] - a[fieldName]
  })
  return objArray
}
